import {ShippingAddressRequest} from "./shippingAddressRequest";
import {CartItemRequest} from "./cartItemRequest";
import {ShippingType} from "../enums/ShippingType";

export class QuickOrderRequest {
  itemsRequest: Array<CartItemRequest>;
  promoCode: string;
  shippingMethod: ShippingType;
  totalAmount: number;
  shippingAddress: ShippingAddressRequest;
  shippingAddressId: number | null;

  constructor(itemsRequest: Array<CartItemRequest>, promoCode: string, shippingMethod: ShippingType, totalAmount: number, shippingAddress: ShippingAddressRequest, shippingAddressId: number | null) {
    this.itemsRequest = itemsRequest;
    this.promoCode = promoCode;
    this.shippingMethod = shippingMethod;
    this.totalAmount = totalAmount;
    this.shippingAddress = shippingAddress;
    this.shippingAddressId = shippingAddressId;
  }
}
